export default {
  cancelRequest({ state, commit }, names) {
    let canceller =
      state.requestCancellers[names.component][names.request];
    if (canceller) {
      canceller();
      commit('removeCanceller', names);
    }
  },
};
